import React from "react";
import { Link } from 'react-router-dom';

class BookBtn extends React.Component {
  render() {
      return(
        <div className="text-center postBigBtn"><Link to="/contact-us" className="btnBorderBig">Book a free design consultation</Link></div>
        );
      }
  }
  
  export default BookBtn;